import emailjs from "emailjs-com";
import { useState } from "react";
const Stories = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const handleSubscribe = async () => {
    if (!email) {
      setMessage("Please enter a valid email.");
      return;
    }

    const templateParams = {
      to_email: email,
    };

    emailjs
      .send(
        "service_eoth74n", // Replace with your EmailJS service ID
        "template_cwivq5l", // Replace with your EmailJS template ID
        templateParams,
        "wtu9NIa5f576DLIT-" // Replace with your EmailJS public key
      )
      .then(
        () => {
          setMessage("Subscription successful! Check your email.");
          setEmail("");
        },
        (error) => {
          setMessage("Error subscribing. Please try again.");
          console.error("EmailJS Error:", error);
        }
      );
  };
  return (
    <>
      <section className="WhatPrcog Stories">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="heading">
                <h6>Our blog</h6>
                <h4>Stories and interviews</h4>
                <p>
                  Subscribe to learn about new product features, the latest in
                  technology, solutions, and updates.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="subscribe">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <button onClick={handleSubscribe} type="button">
                  Subscribe
                </button>
              </div>
              {message && <p className="text-center mt-3">{message}</p>}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Stories;
